import { useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import Device from '../pages/device/DevicePage';
import TestBarcodePage from '../pages/testBarcode/TestBarcodePage';
import OrderStatusPage from '../pages/orderStatus/OrderStatusPage';
import InventoryPage from '../pages/Inventory/InventoryPage';
import ShopifyOrdersPage from '../pages/shopifyOrders/ShopifyOrdersPage';
import NotificationsPage from '../pages/notifications/NotificationsPage';
import AnalyticsPage from '../pages/analytics/AnalyticsPage';
import ConnessioniPage from '../pages/connessioni/ConnessioniPage';
const PrivateRoutes = () => {
  const token = localStorage.getItem('token'); // Get token from storage

  useEffect(() => {
  }, []);

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {token ? (
          <>
            <Route path="devices" element={<Device />} />
            <Route path="barcode" element={<TestBarcodePage />} />
            <Route path="order-status" element={<OrderStatusPage />} />
            <Route path="inventory" element={<InventoryPage />} />
            <Route path="shopify-orders" element={<ShopifyOrdersPage />} />
            <Route path="notifications" element={<NotificationsPage />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="connessioni" element={<ConnessioniPage />} />
          </>
        ) : (
          <Route path="*" element={<Navigate to="/login" replace />} />
        )}

        {/* Page Not Found */}
        {/* <Route path='*' element={<Navigate to='/error/404' />} /> */}
      </Route>
    </Routes>
  )
}

export { PrivateRoutes }
